import { FuelChangesLocations } from "../../../fuel-changes/models/fuel-changes-details.model";

export function applyMapFilter(selectedItem: string, fuelChangesData: FuelChangesLocations[]): FuelChangesLocations[] {

  if (selectedItem === 'Fuel Increases And Decreases Areas') {
    return fuelChangesData;
  }

  if (selectedItem === 'Fuel Increase Areas') {
    return fuelChangesData.filter(item => item.type === 'Fill-Up');
  }

  if (selectedItem === 'Fuel Decrease Areas') {
    return fuelChangesData.filter(item => item.type === 'Loss');
  }

  return [];
}